import i18n from '@/i18n/index.js'

export const getDefaultColumnSettings = () => {
  const { t } = i18n.getInstance().global

  return [
    {
      value: 'name',
      text: t('leads.table.labels.name'),
      visible: true,
    },
    {
      value: 'conversionCountByType.VALUATION',
      text: t('leads.table.labels.valuation'),
      visible: true,
      hideDisplay: true,
    },
    {
      value: 'conversionCountByType.RETURN_CALL',
      text: t('leads.table.labels.return-call'),
      visible: true,
      hideDisplay: true,
    },
    {
      value: 'conversionCountByType.LIFE_ANNUITY',
      text: t('leads.table.labels.life-annuity'),
      visible: true,
      hideDisplay: true,
    },
    {
      value: 'conversionCountByType.PARTIAL_SALE',
      text: t('leads.table.labels.partial-sale'),
      visible: true,
      hideDisplay: true,
    },
    {
      value: 'conversions.download.postalShipping',
      text: t('leads.table.labels.postal-shipping'),
      visible: true,
      hideDisplay: true,
    },
    {
      value: 'conversionCountByType.PLOT_VALUATION',
      text: t('leads.table.labels.plot-valuation'),
      visible: true,
      hideDisplay: true,
    },
    {
      value: 'conversionCountByType.PROPERTY_REQUEST',
      text: t('leads.table.labels.property-request'),
      visible: true,
      hideDisplay: true,
    },
    {
      value: 'conversions.preConversion.type.QUIZ',
      text: t('leads.table.labels.quiz'),
      visible: true,
      hideDisplay: true,
    },
    {
      value: 'conversionCountByType.DOWNLOAD',
      text: t('leads.table.labels.download'),
      visible: true,
      hideDisplay: true,
    },
    {
      value: 'currentStatus',
      text: t('leads.table.labels.status'),
      visible: true,
    },
    {
      value: 'createdAt',
      text: t('leads.table.labels.created'),
      visible: false,
    },
    {
      value: 'propstackCrmTags',
      text: t('leads.table.labels.propstack-crm-tag'),
      visible: true,
    },
    {
      value: 'flowfactCrmTags',
      text: t('leads.table.labels.flowfact-crm-tag'),
      visible: true,
    },
    {
      value: 'onofficeCrmTags',
      text: t('leads.table.labels.onoffice-crm-tag'),
      visible: true,
    },
    {
      text: t('leads.table.labels.property-valuation'),
      value: 'propertyValuation',
      visible: true,
    },
    {
      text: t('leads.table.labels.commission'),
      value: 'commission',
      visible: true,
    },
    {
      value: 'conversions',
      text: t('leads.table.labels.actions'),
      visible: true,
    },
    {
      value: 'lastConversionAt',
      text: t('leads.table.labels.last-action'),
      visible: true,
    },
    {
      value: 'city',
      text: t('leads.table.labels.city'),
      visible: false,
    },
    {
      value: 'assignedUser',
      text: t('leads.table.labels.employee'),
      visible: true,
    },
    {
      value: 'confirmedAt',
      text: t('leads.table.labels.confirmed'),
      visible: true,
    },
    {
      value: 'email',
      text: t('leads.table.labels.email'),
      visible: false,
    },
    {
      value: 'zip',
      text: t('leads.table.labels.zip'),
      visible: true,
    },
    {
      value: 'exportedAt',
      text: t('leads.table.labels.exported'),
      visible: false,
    },
    {
      text: t('leads.table.labels.due-date'),
      value: 'dueDate',
      visible: true,
    },
  ]
}
export const getDefaultHeaders = () => {
  const { t } = i18n.getInstance().global
  return [
    {
      text: t('leads.table.labels.confirmed'),
      value: 'confirmedAt',
      sortable: false,
      width: '20px',
      filterable: false,
    },
    {
      text: t('leads.table.labels.email'),
      value: 'email',
      sortable: false,
    },
    {
      text: t('leads.table.labels.name'),
      value: 'name',
      sortable: false,
    },
    {
      text: t('leads.table.labels.created'),
      value: 'createdAt',
      filterable: false,
      sortable: true,
    },
    {
      value: 'conversions',
      text: t('leads.table.labels.actions'),
      visible: true,
      filterable: false,
      sortable: false,
    },

    {
      text: t('leads.table.labels.last-action'),
      value: 'lastConversionAt',
      filterable: false,
      sortable: true,
    },
    {
      text: t('leads.table.labels.due-date'),
      value: 'dueDate',
      visible: true,
      sortable: true,
    },
    {
      text: t('leads.table.labels.propstack-crm-tag'),
      value: 'propstackCrmTags',
      filterable: false,
    },
    {
      text: t('leads.table.labels.flowfact-crm-tag'),
      value: 'flowfactCrmTags',
      filterable: false,
    },
    {
      text: t('leads.table.labels.onoffice-crm-tag'),
      value: 'onofficeCrmTags',
      filterable: false,
    },
    {
      text: t('leads.table.labels.property-valuation'),
      value: 'propertyValuation',
      filterable: false,
    },
    {
      text: t('leads.table.labels.commission'),
      value: 'commission',
      filterable: false,
    },
    {
      value: 'city',
      text: t('leads.table.labels.city'),
      filterable: false,
      sortable: true,
    },
    {
      value: 'zip',
      text: t('leads.table.labels.zip'),
      filterable: false,
      sortable: true,
    },
    {
      text: t('leads.table.labels.status'),
      value: 'currentStatus',
      sortable: false,
    },
    {
      text: t('leads.table.labels.exported'),
      value: 'exportedAt',
      filterable: false,
      sortable: true,
    },
    {
      text: t('leads.table.labels.employee'),
      value: 'assignedUser',
      sortable: true,
    },
    {
      value: 'conversionCountByType.VALUATION',
      sortable: false,
    },
    {
      value: 'conversionCountByType.RETURN_CALL',
      sortable: false,
    },
    {
      value: 'conversionCountByType.LIFE_ANNUITY',
      sortable: false,
    },
    {
      value: 'conversionCountByType.PARTIAL_SALE',
      sortable: false,
    },
    {
      value: 'conversionCountByType.PROPERTY_REQUEST',
      sortable: false,
    },
    {
      value: 'conversionCountByType.PLOT_VALUATION',
      sortable: false,
    },
    {
      value: 'conversions.download.postalShipping',
      sortable: false,
    },
    {
      value: 'actions',
      align: 'end',
      width: 1,
      sortable: false,
    },
  ]
}
